/** Formats ouvrables dans OnlyOffice (aligné api_suite/coffre-onlyoffice-lib.php). */

export const COFFRE_OFFICE_MAX_BYTES = 100 * 1024 * 1024;

const OFFICE_EXT = new Set([
  "doc",
  "docx",
  "odt",
  "rtf",
  "txt",
  "xls",
  "xlsx",
  "xlsm",
  "ods",
  "csv",
  "ppt",
  "pptx",
  "odp",
]);

const VERSIONABLE_TEXT_EXT = new Set(["txt", "md", "markdown", "mdown", "mkd"]);

function coffreEntryExt(entry) {
  const name = String(entry?.name ?? "").trim();
  const dot = name.lastIndexOf(".");
  if (dot < 1) return "";
  return name.slice(dot + 1).toLowerCase();
}

/**
 * @param {{ kind?: string, name?: string, size?: number | null }} entry
 */
export function coffreCanOpenInOffice(entry) {
  if (!entry || entry.kind !== "file") return false;
  const ext = coffreEntryExt(entry);
  if (!OFFICE_EXT.has(ext)) return false;
  if (entry.size != null && entry.size > COFFRE_OFFICE_MAX_BYTES) return false;
  return true;
}

/**
 * Historique des versions (Office + notes .txt / .md) — pas besoin d’OnlyOffice.
 * @param {{ kind?: string, name?: string, size?: number | null }} entry
 */
export function coffreCanShowVersions(entry) {
  if (!entry || entry.kind !== "file") return false;
  const ext = coffreEntryExt(entry);
  if (VERSIONABLE_TEXT_EXT.has(ext)) return true;
  return coffreCanOpenInOffice(entry);
}
